import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AnyObject } from '@mri/types';

@Component({
  selector: 'app-field-code',
  templateUrl: './field-code.component.html',
  styleUrl: './field-code.component.scss'
})
export class FieldCodeComponent {
  private _value: string;

  get value() {
    return this._value;
  }

  @Input() options?: AnyObject;
  @Input()
  set value(value: string) {
    this._value = value;
  }

  @Output() valueChange = new EventEmitter<string>;


  onChange(value: string){
    this.valueChange.emit(value);
  }

}
